/** Admin: federation partner lifecycle. */
import { apiDelete, apiGet, apiPost } from '../client.js';
import type {
  FederatedPartner,
  FederatedPartnerWithSecret,
} from '../types.js';

export interface ListFederatedPartnersFilters {
  status?: string;
}

export function listFederatedPartners(
  filters: ListFederatedPartnersFilters = {},
): Promise<FederatedPartner[]> {
  return apiGet<FederatedPartner[]>(
    '/api/v1/admin/federated-partners',
    filters.status ? { status_filter: filters.status } : undefined,
  );
}

export interface CreateFederatedPartnerBody {
  name: string;
  idp_name: string;
  description?: string | null;
  contact_email?: string | null;
}

export function createFederatedPartner(
  body: CreateFederatedPartnerBody,
): Promise<FederatedPartnerWithSecret> {
  return apiPost<FederatedPartnerWithSecret>(
    '/api/v1/admin/federated-partners',
    body,
  );
}

export function approveFederatedPartner(id: string): Promise<FederatedPartnerWithSecret> {
  return apiPost<FederatedPartnerWithSecret>(
    `/api/v1/admin/federated-partners/${id}/approve`,
    {},
  );
}

export function rejectFederatedPartner(id: string, reason: string): Promise<FederatedPartner> {
  return apiPost<FederatedPartner>(`/api/v1/admin/federated-partners/${id}/reject`, { reason });
}

export function rotateFederatedPartnerToken(id: string): Promise<FederatedPartnerWithSecret> {
  return apiPost<FederatedPartnerWithSecret>(
    `/api/v1/admin/federated-partners/${id}/rotate`,
    {},
  );
}

export function revokeFederatedPartner(id: string): Promise<FederatedPartner> {
  return apiPost<FederatedPartner>(`/api/v1/admin/federated-partners/${id}/revoke`, {});
}

export function deleteFederatedPartner(id: string): Promise<void> {
  return apiDelete<void>(`/api/v1/admin/federated-partners/${id}`);
}
